import { useCallback, useState } from "react";

/**
|--------------------------------------------------
| 論理型パラメータの初期化（自由指定）
| 
| ★使用例
|   const [flag, changeFlag, resetFlag] = useInitFlag();
|--------------------------------------------------
*/
export function useInitFlag(
    initialValue?: boolean
): [boolean, (value: boolean) => void, () => void] {
    const [value, setValue] = useState<boolean>(initialValue || false);

    const handleChange = useCallback((target) => setValue(target), []);

    const reset = useCallback(() => setValue(false), []);

    return [value, handleChange, reset];
}
